import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle2 ellipsis" }
const _hoisted_2 = { class: "text-h4" }

import SfxCardCondensed from "src/components/card/SfxCardCondensed.vue"
import SfxDataPoint from "src/components/data-point/SfxDataPoint.vue"
import { useCacheStore } from "src/stores/cacheStore"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getAttachmentContent } from "src/util/functions/attachments"
import { getIssuePriorityColor } from "src/util/functions/issuePriority"
import { getWorkOrderPriorityColor } from "src/util/functions/workOrderPriority"
import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { ItemCardData } from "src/util/types/dataModels/item"
import { ItemClass } from "src/util/types/dataModels/itemClass"
import { computed, PropType, ref, watch } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardItemCondensed',
  props: {
  item: {
    type: Object as PropType<ItemCardData>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const cacheStore = useCacheStore()
const storeItem = ref<ItemCardData>()

const itemClassRaw = ref<ItemClass | undefined>(props.item.itemClassData)
const itemIconsRaw = ref(props.item.icons)
const itemThumbnailRaw = ref(props.item.thumbnail)

const itemThumbnail = ref<string | undefined>()
const itemClassDesignation = computed(() => itemClassRaw.value?.designation)
const iconRow = computed(() => itemIconsRaw.value)
const workDone = computed(() => props.item?.regularWork?.conclusion === "accepted")

//endregion

//region Functions

function assignData(item: ItemCardData) {
  storeItem.value = cacheStore.itemCard.get(item.itemData.id)

  assignItemClass(item)
  assignIconRow(item)
  assignThumbnail(item)
}

function assignItemClass(item: ItemCardData) {
  // We already have the data so skip it
  if (itemClassRaw.value) return

  const itemClass = cacheStore.item_class.get(item.itemData.item_class)

  itemClassRaw.value = itemClass

  if (storeItem.value) storeItem.value.itemClassData = itemClass
}

async function assignThumbnail(item: ItemCardData) {
  // We already have the data so skip it
  if (itemThumbnailRaw.value !== undefined) return

  // There is no image, so no point continuing
  if (item.itemData.main_image === null) return

  const attachment = cacheStore.attachment.get(item.itemData.main_image)

  if (attachment) {
    itemThumbnailRaw.value = attachment

    if (storeItem.value) storeItem.value.thumbnail = attachment
  }
}

function assignIconRow(item: ItemCardData) {
  if (itemIconsRaw.value !== undefined) return

  // From left to right, the icon order is:
  // 1. Highest Issue priority
  // 2. Highest Work Order priority
  // 3. Change requests

  const iconRow: IconRowElement[] = []
  iconRow.push(
    {
      name: Icons.ISSUE,
      color: Boolean(item.issuePriorityData)
        ? getIssuePriorityColor(item.issuePriorityData![0])
        : undefined,
    },
    {
      name: Icons.WORK_ORDERS,
      color: Boolean(item.workOrderPriorityData)
        ? getWorkOrderPriorityColor(item.workOrderPriorityData![0])
        : undefined,
    }
  )

  // TODO: Add this icon when we have change requests
  // const dataChangeRequestIcon = {
  //   name: Icons.CHANGE_REQUEST,
  // }
  // iconRow.push(dataChangeRequestIcon)

  itemIconsRaw.value = iconRow

  if (storeItem.value) storeItem.value.icons = iconRow
}

//endregion

//region Setup Code

watch(
  () => itemThumbnailRaw.value,
  async (thumbnail) => {
    itemThumbnail.value = thumbnail
      ? await getAttachmentContent(thumbnail, "item", props.item?.itemData.id)
      : undefined
  },
  { immediate: true }
)

watch(
  () => props.item,
  (newItem) => {
    assignData(newItem)
  },
  { immediate: true }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _directive_truncate_middle = _resolveDirective("truncate-middle")!

  return (_openBlock(), _createBlock(SfxCardCondensed, {
    "img-src": itemThumbnail.value,
    "icon-row": iconRow.value,
    hasImg: "",
    done: workDone.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(itemClassDesignation.value), 1),
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_directive_truncate_middle, props.item?.itemData.designation]
      ]),
      _createVNode(SfxDataPoint, {
        label: _ctx.$t('sfxCard.item_id'),
        "card-field": ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.item.itemData.item_id), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["img-src", "icon-row", "done"]))
}
}

})